<div class="ai-disclaimer-modal modal-content">
  <div class="modal-header">
    <h1 class="modal-title">{{ '::AiDisclaimerModalTitle' | abpLocalization }}</h1>
  </div>

  <div class="modal-body">
    <div class="section">
      <h3>{{ '::AiDisclaimerModalSubTitle1' | abpLocalization }}</h3>
      <p>
        {{ '::AiDisclaimerModalSubConent1' | abpLocalization }}
      </p>
      <p>
        {{ '::AiDisclaimerModalSubConent2' | abpLocalization }}
      </p>
    </div>

    <div class="section">
      <h3>{{ '::AiDisclaimerModalSubTitle2' | abpLocalization }}</h3>
      <p>
        {{ '::AiDisclaimerModalSubConent3' | abpLocalization }}
      </p>
    </div>

    <div class="section">
      <h3>{{ '::AiDisclaimerModalSubTitle3' | abpLocalization }}</h3>
      <p innerHtml="{{ '::AiDisclaimerModalSubConent4' | abpLocalization }}"></p>
    </div>
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="close()">
      {{ '::Close' | abpLocalization }}
    </button>
  </div>
</div>
